export default __webpack_public_path__ + "fr/static/media/logo-avis-verifies-mobile.f30db16b.png";